// Native & external imports
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppRoutes } from './routes';
// Modules
import { LayoutComponent } from '../app/app-layout.module';
import {LoginComponent} from '../components/components.module';
import { NotFoundComponent } from 'src/modules/not-found/not-found.module';
// Routes
// Components
import { PrivacyPolicyComponent } from 'src/components/privacy-policy/privacy-policy.component';
import { TermsAndConditionComponent } from 'src/components/terms-and-condition/terms-and-condition.component';
import { CamperRegistrationComponent } from 'src/components/camper-registration/camper-registration.component';
import { LogoutComponent } from 'src/components/logout/logout.component';
import { RouteGuard } from 'src/app/guards/route-guard';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        canActivate: [RouteGuard],
        path: AppRoutes.componentsUrl.base,
        component: LoginComponent,
        pathMatch: 'full'
      },
      {
        canActivate: [RouteGuard],
        path: AppRoutes.componentsUrl.login,
        component: LoginComponent
      },
      {
        path: AppRoutes.componentsUrl.logout,
        component: LogoutComponent
      },
      {
        canActivate: [RouteGuard],
        path: AppRoutes.componentsUrl.registration,
        component: CamperRegistrationComponent,
        pathMatch: 'full'
      },
      {
        canActivate: [RouteGuard],
        path: AppRoutes.componentsUrl.termsAndCondition,
        component: TermsAndConditionComponent,
        pathMatch: 'full'
      },
      {
        canActivate: [RouteGuard],
        path: AppRoutes.componentsUrl.privacyPolicy,
        component: PrivacyPolicyComponent, 
        pathMatch: 'full'
      },
      {
        canActivate: [RouteGuard],
        path: AppRoutes.componentsUrl.createAccount, 
        component: LoginComponent,
        pathMatch: 'full' 
      }
    ]
  },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes,
    {
      scrollPositionRestoration: 'enabled',
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
